module.exports = __webpack_public_path__ + "img/chess_chesswhite6.e0b1d876.png";